export default __webpack_public_path__ + "static/TurkeyTail-green-e8f691b66e70f5d6fd1aa9491255d6bb.svg";